import { useSelector } from "react-redux";
import React, { useEffect, useState, useMemo } from "react";
import { postRequest } from "../../services/mainApp.service";
import SmartInput from "../../components/NewComponents/SmartInput";
import { message } from "antd";

export default function SettingsPage() {
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);

  const [formData, setFormData] = useState({});

  // Website configuration data
  const [websiteConfigData, setWebsiteConfigData] = useState([]);
  const [websiteConfigDataSaved, setWebsiteConfigDataSaved] = useState([]);

  useEffect(() => {
    const controller = new AbortController(); // make sure this exists here

    const jsonBody = {
      OperationId: 1,
      CompanyId: userData.CompanyId,
      UserId: userData.UserId,
      SettingId: null,
      Value: "",
      UserIP: "12.1.1.12",
      SetupDetailId: null,
    };

    postRequest("/WebConfiguration", jsonBody, controller)
      .then((response) => {
        if (!response) return;
        if (response.error === true) {
          console.error(response.errorconsole);
          return;
        }
        if (response.data.response === false) {
          console.error(response.DataSet.Table.errorMessage);
          return;
        }

        if (response.data.DataSet) {
          setWebsiteConfigData(response?.data?.DataSet?.Table);
          setWebsiteConfigDataSaved(response?.data?.DataSet?.Table1);
        }

      })
      .catch((err) => {
        if (err?.message === "canceled") {
          console.log("Request was cancelled");
        } else {
          console.error("Unexpected error", err);
        }
      });

  }, []);

  useEffect(() => {
    if (websiteConfigDataSaved.length > 0) {
      const initialFormData = {};

      websiteConfigDataSaved.forEach((item) => {
        if (item.SetupDetailId && item.SettingValue !== undefined) {
          initialFormData[item.SetupDetailId] = item.SettingValue;
        }
      });

      console.log("✅ Initial form data:", initialFormData);
      setFormData(initialFormData);
    }
  }, [websiteConfigDataSaved]);




  const handleSave = async () => {
    const payload = {
      OperationId: 2,
      CompanyId: userData.CompanyId,
      UserId: userData.UserId,
      UserIP: "12.1.1.12",
      lstWebConfigurationSetting: Object.entries(formData).map(
        ([key, value]) => ({
          SetupDetailId: parseInt(key, 10),
          Value: value
        })
      )
    };

    try {
      const response = await postRequest("/WebConfiguration", payload, controller);

      if (!response) return;
      if (response.error) {
        console.error(response.errorMessage);
        return;
      }
      if (response.data?.response === false) {
        console.error(response.data?.DataSet?.Table?.errorMessage);
        return;
      }

      message.success("Settings saved successfully!");
    } catch (err) {
      console.error("Save error", err);
      console.error("Failed to save settings.");
    }
  };


  const grouped = websiteConfigData.reduce((acc, item) => {
    if (!acc[item.ParentName]) acc[item.ParentName] = [];
    acc[item.ParentName].push(item);
    return acc;
  }, {});

  const tabKeys = Object.keys(grouped);
  const [activeTab, setActiveTab] = useState(tabKeys[0]);
;

// 👇 Set first tab when available
useEffect(() => {
  if (tabKeys.length > 0 && !activeTab) {
    setActiveTab(tabKeys[0]);
  }
}, [tabKeys, activeTab]);



  return (
    <div className="container pt-2">
      <div className="mb-2">
        <h1 className="text-3xl font-bold mb-2">Website Settings</h1>

      </div>

      {/* Custom Tabs Navigation */}
      <div className="w-full flex justify-center mb-2">
        <div className="inline-flex items-center justify-center flex-wrap gap-2 rounded-full bg-white p-2 mb-4 mx-auto">
          {tabKeys.map((tab) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                
              }}
              className={` px-4 py-1.5 rounded-full font-medium text-[16px] transition  ${activeTab === tab
                ? "bg-[#017971] text-white shadow"
                : "bg-white text-gray-700 hover:bg-[#017971] hover:text-white"
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

      </div>


      {/* Tab Content */}
      <div className="px-4 space-y-2">
        {grouped[activeTab] && (
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2">
              {grouped[activeTab]?.map((child) => (
                <div key={child.SetupDetailId} className="px-4 py-2 rounded">
                  <SmartInput
                    child={child}
                    value={formData[child.SetupDetailId] ?? ""}
                    onChange={(val) =>
                      setFormData((prev) => ({
                        ...prev,
                        [child.SetupDetailId]: val,
                      }))
                    }
                  />
                </div>
              ))}
            </div>
            <div className="text-right mt-4">
              <button
                className="px-6 py-2 rounded-full bg-[#017971] text-white hover:bg-[#017971]"
                onClick={() => handleSave()}
              >
                Save {activeTab}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>

  );
}
